import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Breadcrumb extends Component {
    render() {
        const { title, breadcrumbPath = [] } = this.props;
        
        return (
            <section className="section breadcrumb-area bg-overlay d-flex align-items-center">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            {/* Breamcrumb Content */}
                            <div className="breadcrumb-content d-flex flex-column align-items-center text-center">
                                <h2 className="text-white">{title}</h2>
                                <ol className="breadcrumb justify-content-center">
                                    <li className="breadcrumb-item"><Link className="text-white" to="/">Home</Link></li>
                                    {breadcrumbPath.map((item, index) => (
                                        <li key={index} className="breadcrumb-item">
                                            {item.link ? (
                                                <Link className="text-white" to={item.link}>{item.text}</Link>
                                            ) : (
                                                <span className="text-white">{item.text}</span>
                                            )}
                                        </li>
                                    ))}
                                    <li className="breadcrumb-item active text-white">{title}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Breadcrumb;